import React, { forwardRef } from "react";
import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import OutlinedInput from "@mui/material/OutlinedInput";

const TextInput = forwardRef(
  (
    { type, onErrorCheck, control, name, onEmailCheck, getValues, ...props },
    ref
  ) => {
    const handleChange = async (event, onChange) => {
      let value = event.target.value;

      // Update form value with react-hook-form onChange
      onChange(value);

      if (name === "newPassword") {
        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/;
        if (!regex.test(value)) {
          if (onErrorCheck && typeof onErrorCheck === "function") {
            onErrorCheck(
              "Password must be at least 8 characters long and include uppercase, lowercase, and numbers."
            );
          }
        } else {
          if (onErrorCheck && typeof onErrorCheck === "function") {
            onErrorCheck("Looks good!"); // Clear error
          }
        }
      }

      if (name === "confirmNewPassword") {
        const newPassword = getValues("newPassword"); // Get newPassword value from react-hook-form

        if (newPassword !== value) {
          if (onErrorCheck && typeof onErrorCheck === "function") {
            onErrorCheck("Passwords do not match.");
          }
        } else {
          if (onErrorCheck && typeof onErrorCheck === "function") {
            onErrorCheck("Passwords match!");
          }
        }
      }
    };

    const [showPassword, setShowPassword] = React.useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
      event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
      event.preventDefault();
    };

    return (
      <Controller
        name={name}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <TextField
            type={showPassword ? "text" : "password"} // Toggles between "text" and "password"
            error={Boolean(error)}
            helperText={error?.message || ""}
            inputRef={ref}
            value={value || ""}
            fullWidth
            onChange={(e) => handleChange(e, onChange)}
            slotProps={{
              input: {
                sx: {
                  fontSize: "16px",
                  borderRadius: "25px",
                  color: "black", // Input text color
                  backgroundColor: "white", // Input background color
                  "& fieldset": {
                    borderColor: "#ccc", // Default border color
                  },
                  "&:hover fieldset": {
                    borderColor: "#999", // Border color on hover
                  },
                  // "&.Mui-focused fieldset": {
                  //   borderColor: "transparent", // Border color on focus
                  //   outline: "none", // Remove outline
                  // },
                },

                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label={
                        showPassword
                          ? "hide the password"
                          : "display the password"
                      }
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      onMouseUp={handleMouseUpPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              },
            }}
          />
        )}
      />
    );
  }
);

TextInput.propTypes = {
  type: PropTypes.string,
  onErrorCheck: PropTypes.func,
  onEmailCheck: PropTypes.func,
};
export default TextInput;
